export const size = {
    mobile: '425px',
    tablet: '768px',
    laptop: '1024px',
    laptopL: '1200px',
    desktop: '2560px'
};

export const device = {
    mobile: `(max-width: ${size.mobile})`,
    tablet: `(max-width: ${size.tablet})`,
    laptop: `(max-width: ${size.laptop})`,
    laptopL: `(max-width: ${size.laptopL})`,
    desktop: `(max-width: ${size.desktop})`
};
